<template>
  <div class="container top-0 position-sticky z-index-sticky">
    <div class="row">
      <div class="col-12">
        <navbar
          isBlur="blur  border-radius-lg my-3 py-2 start-0 end-0 mx-4 shadow"
          v-bind:darkMode="true"
          isBtn="bg-gradient-success"
        />
      </div>
    </div>
  </div>
  <main class="mt-0 main-content">
    <section>
      <div class="page-header min-vh-100">
        <div class="container">
          <div class="row">
            <div class="mx-auto col-xl-4 col-lg-5 col-md-7 d-flex flex-column mx-lg-0">
              <div class="card card-plain">
                <div class="pb-0 card-header text-start">
                  <h4 class="font-weight-bolder">Sign In to Tofali Africa Admin</h4>
                  <p class="mb-0">Enter your email and password to sign in</p>
                </div>
                <div class="card-body">
                  <form role="form" @submit.prevent="submitForm">
                    <div class="mb-3">
                      <input class="form-control" type="email" placeholder="Email" name="email" v-model="username" />
                    </div>
                    <div class="mb-3">
                      <input class="form-control" type="password" placeholder="Password" name="password" v-model="password" />
                    </div>

                    <div class="notification danger" v-if="errors.length">
                        <p v-for="error in errors" v-bind:key="error">{{ error }}</p>
                    </div>
                    

                    <div class="text-center">
                      <argon-button
                        class="mt-4"
                        variant="gradient"
                        color="success"
                        fullWidth
                        size="lg"
                      >Sign in</argon-button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </main>
</template>

<script>
import Navbar from "@/examples/PageLayout/Navbar.vue";
//import ArgonInput from "@/components/ArgonInput.vue";
import ArgonButton from "@/components/ArgonButton.vue";
const body = document.getElementsByTagName("body")[0];
import axios from 'axios'

export default {
  name: "signin",
  data(){
    return {
      username: '',
      password: '',
      errors: []
    }
  },
  components: {
    Navbar,
    //ArgonInput,
    ArgonButton,
  },
  mounted() {
        document.title = 'Log In | Tofali Africa'
  },
  methods:{
    submitForm() {
            axios.defaults.headers.common["Authorization"] = ''

            localStorage.removeItem("access")

            const formData = {
                email: this.username,
                password: this.password
            }

            axios
                .post("/api/v1/jwt/create/", formData)
                .then(response => {
                    //console.log(respose)
                    const access= response.data.access
                    const refresh = response.data.refresh
                                   
                    this.$store.commit('setAccess', access)
                    this.$store.commit('setRefresh', refresh)
                    this.$store.commit('setUsername', this.username)
                    
                    axios.defaults.headers.common["Authorization"] = "JWT " + access

                    localStorage.setItem("access", access)
                    localStorage.setItem("refresh", refresh)
                    //localStorage.setItem("username", this.username)
                    
                    const toPath = this.$route.query.to || '/'

                    this.$router.push(toPath)

                    //if (response.status === 200) {
                        //console.log(username)
                        //this.$router.push({ name:'Cart' })
                        //localStorage.setItem('username', username);
                    //}}
                })
                .catch(error => {
                    if (error.response) {
                        for (const property in error.response.data) {
                            this.errors.push(`${error.response.data[property]}`)
                        }
                    } else {
                        this.errors.push('Something went wrong. Please try again')   
                        console.log(JSON.stringify(error))
                    }
                })
        }
  },
  created() {
    this.$store.state.hideConfigButton = true;
    this.$store.state.showNavbar = false;
    this.$store.state.showSidenav = false;
    this.$store.state.showFooter = false;
    body.classList.remove("bg-gray-100");
  },
  beforeUnmount() {
    this.$store.state.hideConfigButton = false;
    this.$store.state.showNavbar = true;
    this.$store.state.showSidenav = true;
    this.$store.state.showFooter = true;
    body.classList.add("bg-gray-100");
  },
};
</script>
